import { render, staticRenderFns } from "./order-type-groups.component.vue?vue&type=template&id=64540d7c&"
import script from "./order-type-groups.component.ts?vue&type=script&lang=ts&"
export * from "./order-type-groups.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports